module.exports = __webpack_public_path__ + "img/9788996103103.1947bf75.jpg";